export default __webpack_public_path__ + "static/media/cyber-party.dac86bb6.jpg";